/**
 * Banner component
 */

/* Imports */

import React from "react";
import Button from "../Button";
import { Banner, BannerText } from "./styles.module.scss";

/* Component */

const BannerComponent = ({ text = "" }) => {
  return (
    <div className={`${Banner} lc-banner lc-ff-display lc-off-white lc-tx`}>
      <div className="lc-container" data-p="s">
        <div
          className="lc-flex"
          data-gap="xs"
          data-align="center"
          data-justify="center"
        >
          <div className={`${BannerText} lc-banner__text`}>{text}</div>
          <div className="lc-flex lc-flex-shrink-0">
            <Button
              outline
              theme="off-white"
              text="Sign Up"
              link="https://later.com/newsletter-subscribe/"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

/* Export */

export default BannerComponent;
